import { createFileRoute } from '@tanstack/react-router';
import { AdminBroadcastsView } from '@/components/admin/AdminBroadcastsView';
import {
  resolveBroadcastListStatus,
  type BroadcastListStatus,
  type BroadcastsPageParams,
} from '@/lib/queries/broadcasts';

interface BroadcastsSearch {
  readonly status?: BroadcastListStatus;
  readonly q?: string;
  readonly cursor?: string;
}

export const Route = createFileRoute('/_authed/admin/broadcasts/')({
  validateSearch: (raw: Record<string, unknown>): BroadcastsSearch => {
    const status = resolveBroadcastListStatus(raw.status);
    const q = typeof raw.q === 'string' && raw.q.length > 0 ? raw.q : undefined;
    const cursor =
      typeof raw.cursor === 'string' && raw.cursor.length > 0
        ? raw.cursor
        : undefined;
    return {
      ...(status !== undefined ? { status } : {}),
      ...(q !== undefined ? { q } : {}),
      ...(cursor !== undefined ? { cursor } : {}),
    };
  },
  component: AdminBroadcastsPage,
});

function AdminBroadcastsPage() {
  const search = Route.useSearch();
  const active: BroadcastListStatus = search.status ?? 'all';

  const listParams: BroadcastsPageParams = {
    pageSize: 25,
    ...(active !== 'all'
      ? { status: active as Exclude<BroadcastListStatus, 'all'> }
      : {}),
    ...(search.cursor ? { cursor: search.cursor } : {}),
  };

  return (
    <AdminBroadcastsView
      listParams={listParams}
      active={active}
      searchQuery={search.q}
      cursor={search.cursor}
    />
  );
}
